import React from 'react';
import { FormattedMessage } from 'react-intl';
import VendorResources from './VendorResources';

export const route = {
  path: '/vendors/:slug/resources',
  title: () => <FormattedMessage id="vendorTabs.resources" />,
  component: VendorResources
};
